










import Vue from "vue";
import Component from "vue-class-component";
@Component({
  props: {
    showDate: {
      type: String,
      default: '',
    }
  },
})
export default class nodataC extends Vue {
  reselect(){
    this.$bus.$emit("reSelctTime")
  }
}
